export default __webpack_public_path__ + "static/tabs-independent-dont-bd3995155c9752c9692f70c01613009b.png";